import axios from 'axios'
import helpers from "@/helpers";

export default {
    getQuickAccesses({commit}) {

        axios.get(process.env.VUE_APP_API_URL + `/quickaccess`)
            .then(response => (commit('setQuickAccesses', response.data.data)))
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getQuickAccessById({commit}, quickAccessId) {

        axios.get(process.env.VUE_APP_API_URL + `/quickaccess/${quickAccessId}`)
            .then(response => {
                commit('setQuickAccess', response.data.data)
            })
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    storeQuickAccess({commit}, quickAccess) {

        axios.put(process.env.VUE_APP_API_URL + `/quickaccess/${quickAccess.id}`, quickAccess)
            .then(() => {
                helpers.handleSuccessMessage("Der Schnellzugriff wurde gespeichert.", "Gespeichert")
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Schnellzugriff konnte nicht gespeichert werden!")
            })

        commit('none')
    },
    createQuickAccess({commit}, quickAccess) {


        axios.post(process.env.VUE_APP_API_URL + `/quickaccess`, quickAccess)
            .then(response => {
                helpers.handleSuccessMessage("Der Schnellzugriff wurde erstellt.", "Erstellt")
                window.location = '/Schnellzugriffe/' + response.data.data.id
            }).catch(exception => {
            helpers.handleMildAxiosError(exception)
        })
        commit('resetNewQuickAccess')
    },
    deleteQuickAccess({commit}, quickAccess) {


        axios.delete(process.env.VUE_APP_API_URL + `/quickaccess/${quickAccess.id}`)
            .then(() => {
                helpers.handleSuccessMessage("Der Schnellzugriff wurde gelöscht.", "Gelöscht")
                window.location = '/Schnellzugriffe/'
                commit('clearQuickAccesses');
            })
            .catch(() => {
                helpers.handleMildAxiosError("Der Schnellzugriff konnte nicht gelöscht werden.")
            })
    },
    saveQuickAccessPositions({commit, dispatch}, { quickAccesses }) {
        axios.post(process.env.VUE_APP_API_URL + '/quickaccesses/position', quickAccesses)
            .then(() => {
                commit('clearQuickAccesses')
                dispatch('getQuickAccesses')
                helpers.handleSuccessMessage("Reihenfolge gespeichert!")
            })
            .catch(() => {
                helpers.handleWarningMessage("Die Reihenfolge konnte nicht gespeichert werden!")
            })
    }
}
